/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Custom Remove button
 */

import { Button as AntButton, Tooltip, ButtonProps } from 'antd';
import { Close } from '@icon-park/react';

/**
 * Remove
 */
const Remove: React.FC<ButtonProps> = ({ title = 'Remove', ...restProps }) => {
	const key = `remove-btn-${restProps.disabled ? 'disabled' : 'enabled'}`;
	return (
		<Tooltip title={title}>
			<AntButton key={key} color='default' variant='filled' {...restProps}>
				<Close color='red' />
			</AntButton>
		</Tooltip>
	);
};

export default Remove;
